/* global Geocomplete, gon */

require('geocomplete/jquery.geocomplete.js')

window.Geocomplete || (window.Geocomplete = {})

Geocomplete.loadGMAPS = function (callback) {
  if (_.isUndefined(window.google) || _.isUndefined(window.google.maps)) {
    if (document.getElementById('gmaps') && _.isFunction(callback)) {
      $('#gmaps').on('load', callback)
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.id = 'gmaps'
      script.onload = function () {
        _.isFunction(callback) && callback()
      }
      script.src = `//maps.googleapis.com/maps/api/js?key=${gon.application.gmaps_key}&language=de&libraries=places&loading=async&v=weekly`
      document.getElementsByTagName('head')[0].appendChild(script)
    }
  } else {
    _.isFunction(callback) && callback()
  }
}

Geocomplete.initMap = function (inputSelector, mapSelector) {
  Geocomplete.loadGMAPS(function () {
    if (inputSelector == null) {
      inputSelector = '#gmaps-input-address'
    }
    if (mapSelector == null) {
      mapSelector = '#gmaps-canvas'
    }
    const geocomplete = $(inputSelector).geocomplete({
      map: mapSelector,
      componentRestrictions: { country: [] },
      markerOptions: { draggable: false }
    })
    geocomplete.bind('geocode:result', function (event, result) {
      $(mapSelector).css('opacity', 1)
    })
    geocomplete.bind('geocode:dragged', function (event, latLng) {
      $(inputSelector).geocomplete('find', latLng.lat() + ',' + latLng.lng())
    })
    $(inputSelector).trigger('geocode')

    return $(inputSelector).geocomplete('map')
  })
}

Geocomplete.initSelect = function (opts, callback) {
  Geocomplete.loadGMAPS(function () {
    if (callback == null) callback = function () { }
    if (opts == null) opts = {}
    const inputSelector = opts.input || '#gmaps-input-address'
    const detailsSelector = opts.details || '.details'
    const detailsAttribute = opts.details_attr || 'data-geo'
    const init = () => {
      $(inputSelector).geocomplete({
        details: detailsSelector,
        detailsAttribute,
        componentRestrictions: {
          country: []
        }
      }).on('geocode:result', function (event, result) {
        const findInResult = (type) => {
          return result.address_components.find(item => item.types.includes(type))?.short_name || ''
        }

        const streetAddress = findInResult('route') + ' ' + findInResult('street_number')
        $(`[${detailsAttribute}=street_address]`, detailsSelector).val(streetAddress)

        return callback(result)
      })
    }

    $(inputSelector).on('keyup', init)
    $(inputSelector).trigger('geocode')
    $(inputSelector).one('focus', function () {
      $(this).attr('autocomplete', 'none')
    })
    $(inputSelector).on('keyup', function () {
      if ($(this).val() === '') {
        $(detailsSelector).find('input').val('')
      }
    })
  })
}
